import { DeadlineRule, FundTypeFormat } from './deadline-rules.model';
import { addCalendarDays, addWorkingDays } from './deadline-rules.utils';

// Deadline offsets (calendar/working days) based on regulator guidance.
const MONTHLY_WORKING_DAYS = 5;
const BAFIN_BASE_CALENDAR_DAYS = 30;
const BAFIN_FOF_EXTRA_CALENDAR_DAYS = 15;
const QUARTERLY_STANDARD_CALENDAR_DAYS = 60;
const QUARTERLY_YEAR_END_CALENDAR_DAYS = 120;
const QUARTERLY_FOF_STANDARD_CALENDAR_DAYS = 120;
const QUARTERLY_FOF_YEAR_END_CALENDAR_DAYS = 180;

export const DEADLINE_RULES: DeadlineRule[] = [
  {
    id: 'z4',
    reportName: 'Z4',
    regulator: 'Bundesbank',
    frequency: 'monthly',
    // 5 working days after month-end.
    computeDeadline: (periodEnd: Date) =>
      addWorkingDays(periodEnd, MONTHLY_WORKING_DAYS),
  },
  {
    id: 'dcr',
    reportName: 'DCR',
    regulator: 'Bundesbank',
    frequency: 'monthly',
    // 5 working days after month-end.
    computeDeadline: (periodEnd: Date) =>
      addWorkingDays(periodEnd, MONTHLY_WORKING_DAYS),
  },
  {
    id: 'bafin-annex-iv',
    reportName: 'BaFin Annex IV',
    regulator: 'BaFin',
    frequency: 'quarterly',
    computeDeadline: (periodEnd: Date, fundType?: FundTypeFormat) => {
      // 30 calendar days after quarter-end (+15 for FoF).
      const fofExtra =
        fundType === FundTypeFormat.FundOfFunds
          ? BAFIN_FOF_EXTRA_CALENDAR_DAYS
          : 0;
      return addCalendarDays(periodEnd, BAFIN_BASE_CALENDAR_DAYS + fofExtra);
    },
  },
  {
    id: 'quarterly-lp-report',
    reportName: 'Quarterly Report',
    regulator: 'ILPA',
    frequency: 'quarterly',
    computeDeadline: (periodEnd: Date, fundType?: FundTypeFormat) => {
      const isYearEndQuarter = periodEnd.getMonth() === 11;

      if (fundType === FundTypeFormat.FundOfFunds) {
        // FoF timelines: 120 days (standard) or 180 days (year-end).
        return addCalendarDays(
          periodEnd,
          isYearEndQuarter
            ? QUARTERLY_FOF_YEAR_END_CALENDAR_DAYS
            : QUARTERLY_FOF_STANDARD_CALENDAR_DAYS
        );
      }

      // Standard timelines: 60 days (standard) or 120 days (year-end).
      return addCalendarDays(
        periodEnd,
        isYearEndQuarter
          ? QUARTERLY_YEAR_END_CALENDAR_DAYS
          : QUARTERLY_STANDARD_CALENDAR_DAYS
      );
    },
  },
];
